import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "TransferCustomer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "itemModal" }
const _hoisted_5 = { class: "itemModal" }
const _hoisted_6 = { style: {"font-size":"16px"} }
const _hoisted_7 = { class: "dialog-footer" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {customerTableConfig} from './config/customer.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData, getPageListData, postData} from '@/service/main/system'
import {useStore} from '@/store'
import {initEmptyParam} from "@/hooks/useInitParam";
import localCache from "@/utils/cache";
import {ref, watch} from 'vue';
import LfTable from "@/components/LfTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TransferCustomer',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getEventList = async () => {
  let eventData = await getListData('/main/transferCustomer/getEventList', {})
  const eventOptions = eventData.map((item: any) => {
    return {title: item.eventName, value: item.eventName}
  })
  const eventItem = searchFormConfig.formItems.find((item) => item.field === 'eventName')
  eventItem!.options = eventOptions
}
getEventList()

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.id};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'initiator')
  userItem!.options = userOptions;
}
getEmp()

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const tableTitle = ref('');
const dataList = ref<any[]>([])
const dataCount = ref<number>(0)
const pageInfo = ref({pageNo: 1, pageSize: 10})
let queryItemInfo = {eventId: -1, pageNo: 1, pageSize: 10}

const handleViewClick = (item: any) => {
  console.log(item)
  dialogVisible.value = true;
  dialogTitle.value = '转移记录'
  tableTitle.value = '客户列表'
  getPageData(item.id);
}

const getPageData = async (id: number) => {
  queryItemInfo = {
    eventId: id,
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize
  }

  const data = await getPageListData(
    '/main/transferCustomer/getCustomersById',
    queryItemInfo
  )
  dataList.value = data.list
  dataCount.value = Number(data.total)
}

const dialogClose = () => {
  dataList.value = [];
  pageInfo.value.pageNo = 1;
  pageInfo.value.pageSize = 10;
  dataCount.value = 0;
}
watch(pageInfo, () => getPageData(queryItemInfo.eventId))

const tipDialogVisible = ref(false)
const eventInfo = ref()
const handleApproval = (row: any) => {
  tipDialogVisible.value = true
  eventInfo.value = row
}

const approvalResult = async (result: any) => {
  await postData('/main/transferCustomer/eventApproval', {isAgree: result, eventId: eventInfo.value.id})
  tipDialogVisible.value = false
  pageContentRef.value?.getPageData()
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "transferCustomer",
      onViewClick: handleViewClick,
      onSortChange: handleSortChange
    }, {
      type: _withCtx((scope) => [
        (scope.row.transferType === '0')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "在职业务员客户"))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, "离职未分配业务员客户"))
      ]),
      status: _withCtx((scope) => [
        (scope.row.approvalStatus === '0')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "mini",
              type: "primary",
              onClick: ($event: any) => (handleApproval(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode("审批 ")
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (scope.row.approvalStatus === '1')
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                size: "mini",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("审批通过")
                ]),
                _: 1
              }))
            : (scope.row.approvalStatus === '2')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 2,
                  size: "mini",
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("审批拒绝")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_dialog, {
        title: dialogTitle.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
        width: "50%",
        center: "",
        "destroy-on-close": "",
        onClosed: dialogClose
      }, {
        default: _withCtx(() => [
          _createVNode(LfTable, _mergeProps({
            listData: dataList.value,
            listCount: dataCount.value,
            title: tableTitle.value
          }, _unref(customerTableConfig), {
            page: pageInfo.value,
            "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((pageInfo).value = $event))
          }), {
            status: _withCtx((scope) => [
              (scope.row.status === '0')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    size: "mini",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("待审批")
                    ]),
                    _: 1
                  }))
                : (scope.row.status === '-1')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      size: "mini",
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("接替失败")
                      ]),
                      _: 1
                    }))
                  : (scope.row.status === '1')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        size: "mini",
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("接替完毕")
                        ]),
                        _: 1
                      }))
                    : (scope.row.status === '2')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 3,
                          size: "mini",
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("等待接替")
                          ]),
                          _: 1
                        }))
                      : (scope.row.status === '3')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 4,
                            size: "mini",
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("客户拒绝")
                            ]),
                            _: 1
                          }))
                        : (scope.row.status === '4')
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 5,
                              size: "mini",
                              type: "warning"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("达到上限")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
            ]),
            _: 1
          }, 16, ["listData", "listCount", "title", "page"])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_dialog, {
        modelValue: tipDialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tipDialogVisible).value = $event)),
        title: "转移审批",
        width: "30%",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (approvalResult(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("拒绝")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (approvalResult(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("同意")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, " 是否同意 “" + _toDisplayString(eventInfo.value.handoverUserid) + "” 选中的" + _toDisplayString(eventInfo.value.customerNum) + "个客户转移到 “" + _toDisplayString(eventInfo.value.takeoverUserid) + "” 中 ", 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})